import {
  updatePayloadGroupName,
  updatePayloadGroupDescription,
  updatePayloadJurisdiction,
  updatePayloadDataAggregation,
  updatePayloadTrendAnalysis,
  updatePayloadUserFeedback,
  updatePayloadExportToggle,
  updatePayloadChatbot,
  updatePayloadBenefits,
  uploadPayloadWorkforces,
  updatePayloadUseCases,
  updatePayloadPersona,
  updatePayloadPOI,
  updatePayloadChatbotCopy,
  updatePayloadChatbotExport
} from './UpdateDetails'

export const saveUpdateProject = (
  updateProjectDetails,
  handleUpdate,
  handleClickOpen,
  setNavigateToProjectList,
  isCustomSettings = false,
  refetchGroupPermission = null,
  refetchGroups = null
) => {
  const {
    projectId,
    exit,
    projectName,
    setCurrentGroupName,
    currentDescription,
    projectDescription,
    currentJurisdiction,
    currentDataAggregation,
    selectedJurisdiction,
    selectedDataAggregation,
    currentUseCases,
    selectedUseCases,
    selectedFilters,
    selectedBenefits,
    selectedWorkforces,
    currentWorkforces,
    setShowNotification,
    setInputDisabled,
    trendAnalysisFlag,
    userFeedbackFlag,
    selectedTrendAnalysis,
    selectedUserFeedback,
    exportFlag,
    selectedExportToggle,
    chatbotFlag,
    chatbotCopyFlag,
    chatbotExportFlag,
    selectedChatbot,
    selectedChatbotExport,
    selectedChatbotCopy,
    currentPOI,
    selectedPOI,
    personaFlag,
    selectedPersona,
    closeExistingEventFlag
  } = updateProjectDetails

  const updatePayload = {}
  if (!isCustomSettings) {
    updatePayload.groupId = Number.parseInt(projectId)
    updatePayloadGroupName(projectName, updatePayload, setCurrentGroupName)
    updatePayloadGroupDescription(currentDescription, projectDescription, updatePayload)
  }
  updatePayload.trendAnalysisFlag = selectedTrendAnalysis
  updatePayload.userFeedbackFlag = selectedUserFeedback
  updatePayload.chatbotFlag = selectedChatbot
  updatePayload.personaFlag = selectedPersona
  updatePayload.selectedChatbotExport = selectedChatbotExport
  updatePayload.selectedChatbotCopy = selectedChatbotCopy
  updatePayloadJurisdiction(currentJurisdiction, selectedJurisdiction, updatePayload)
  updatePayloadDataAggregation(currentDataAggregation, selectedDataAggregation, updatePayload)
  const {updatePayloadFilters} = require('./UpdateDetails')
  updatePayloadFilters(
    updateProjectDetails.currentFilters || [],
    updateProjectDetails.selectedFilters || [],
    updatePayload
  )
  updatePayloadUseCases(currentUseCases, selectedUseCases, updatePayload)
  updatePayloadBenefits(selectedBenefits, updatePayload)
  uploadPayloadWorkforces(currentWorkforces, selectedWorkforces, updatePayload)
  updatePayloadTrendAnalysis(trendAnalysisFlag, selectedTrendAnalysis, updatePayload)
  updatePayloadUserFeedback(userFeedbackFlag, selectedUserFeedback, updatePayload)
  updatePayloadExportToggle(exportFlag, selectedExportToggle, updatePayload)
  updatePayloadPersona(personaFlag, selectedPersona, updatePayload)
  updatePayloadChatbot(chatbotFlag, selectedChatbot, updatePayload)
  updatePayload.closeExistingEventFlag = closeExistingEventFlag
  updatePayloadChatbotExport(chatbotExportFlag, selectedChatbotExport, updatePayload)
  updatePayloadChatbotCopy(chatbotCopyFlag, selectedChatbotCopy, updatePayload)
  if (isCustomSettings) {
    updatePayload.pointOfInterest = selectedPOI.map((element) => element.POI_ID)
  } else {
    updatePayloadPOI(currentPOI, selectedPOI, updatePayload)
  }
  const updateDetails = {
    projectName,
    selectedJurisdiction,
    selectedFilters,
    selectedUseCases,
    exit,
    updatePayload,
    setInputDisabled,
    selectedTrendAnalysis,
    selectedUserFeedback,
    selectedExportToggle,
    selectedChatbot,
    selectedBenefits,
    selectedWorkforces,
    selectedPOI,
    selectedPersona
  }
  handleUpdate(
    updateDetails,
    handleClickOpen,
    setShowNotification,
    setNavigateToProjectList,
    refetchGroupPermission,
    refetchGroups
  )
}
// selected options includes all checks for the selected options in admin panel
export const checkBlankInputCompletedProject = (isCompleted, projectName, selectedOptions) => {
  const {
    selectedJurisdiction,
    selectedFilters,
    selectedTrendAnalysis,
    selectedUserFeedback,
    selectedExportToggle,
    selectedChatbot,
    selectedExportPermission,
    selectedCopyPastePermission,
    selectedPersona
  } = selectedOptions
  return (
    !isCompleted &&
    (projectName.length === 0 ||
      selectedJurisdiction.length === 0 ||
      selectedFilters.length === 0 ||
      selectedTrendAnalysis?.length === 0 ||
      selectedUserFeedback?.length === 0 ||
      selectedExportToggle?.length === 0 ||
      selectedChatbot?.length === 0 ||
      selectedPersona?.length === 0 ||
      selectedCopyPastePermission?.length === 0 ||
      selectedExportPermission?.length === 0)
  )
}
